import { useState, useEffect } from "react";
import Header from "./pages/Header";
import Home from "./pages/Home";
import About from "./pages/About";
import Academy from "./pages/Academy";
import TechInterview from "./pages/TechInterview";
import Footer from "./pages/Footer";
import "./App.css";

export default function App() {
  const [page, setPage] = useState("home");

  
  useEffect(() => {
    const titles: Record<string, string> = {
      home: "GeoAlpha | Home",
      about: "GeoAlpha | About",
      academy: "GeoAlpha | Academy",
      tech: "GeoAlpha | Tech Interview",
    };

    document.title = titles[page] || "GeoAlpha";
  }, [page]);

  return (
    <>
      <Header onNavigate={setPage} />

      {page === "home" && <Home />}
      {page === "about" && <About />}
      {page === "academy" && <Academy />}
      {page === "tech" && <TechInterview />}

      <Footer />
    </>
  );
}